import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver filed a training report.
 */
export const trainingReportV1 = tmsEventKind(
  { category: "training", kind: "trainingReport", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      trainingType: z.string().nullable(),
    },
  },
);

export const TrainingReportV1Schema = trainingReportV1.schema;
export const TrainingReportV1FactsSchema = trainingReportV1.facts;

export type TrainingReportV1 = z.infer<typeof TrainingReportV1Schema>;
export type TrainingReportV1Facts = z.infer<typeof TrainingReportV1FactsSchema>;

/** Every version of `trainingReport`, keyed by version. What `catalog.ts` places under `training`. */
export const trainingReport = { 1: trainingReportV1 } as const;
